'use client';

import Link from 'next/link';
import { useGardenReminders } from '@/hooks/useGardenReminders';

function BellIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 7.5A5 5 0 0 0 4 7.5C4 12 2.5 13 2.5 13h13S14 12 14 7.5Z" />
      <path d="M7.25 15a2 2 0 0 0 3.5 0" />
    </svg>
  );
}

export default function GardenReminderToast() {
  const {
    reminders,
    dismissReminder,
    disableReminders,
  } = useGardenReminders();

  const reminder = reminders[0];
  if (!reminder) return null;

  return (
    <div className="fixed bottom-5 left-4 right-4 z-50 md:left-auto md:right-6 md:max-w-sm">
      <div className="bg-white border border-sand rounded-xl shadow-lg px-4 py-3">
        <div className="flex items-start gap-3">
          <span className="text-sage mt-0.5 flex-shrink-0">
            <BellIcon />
          </span>
          <div className="min-w-0 flex-1">
            <p className="font-body text-[12px] text-sage uppercase tracking-wider font-semibold">
              Garden Reminder
            </p>
            <p className="font-body text-[15px] text-dark-text font-semibold mt-0.5 leading-snug">
              {reminder.title}
            </p>
            {reminder.description && (
              <p className="font-body text-[13px] text-sage mt-1 leading-snug">
                {reminder.description}
              </p>
            )}
            <div className="flex flex-wrap items-center gap-3 mt-3">
              {reminder.plantId && (
                <Link
                  href={`/plants/${reminder.plantId}`}
                  onClick={() => dismissReminder(reminder.id)}
                  className="font-body text-[13px] font-semibold text-deep-green hover:underline"
                >
                  Open plant guide
                </Link>
              )}
              <button
                onClick={() => dismissReminder(reminder.id)}
                className="font-body text-[13px] font-semibold text-sage hover:text-dark-text"
              >
                Dismiss
              </button>
              <button
                onClick={disableReminders}
                className="font-body text-[12px] text-sage hover:text-dark-text"
              >
                Turn off reminders
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
